import {api} from '../api';
import {Knowledge, KnowledgeForm, KnowledgeMode, UploadProgress} from '../types';
import {uploadKnowledge} from './upload';

interface SaveRequest {mode: KnowledgeMode; form: KnowledgeForm; file: File | null; editing: Knowledge | null; onProgress: (progress: UploadProgress) => void}
export async function saveKnowledge({mode, form, file, editing, onProgress}: SaveRequest): Promise<Knowledge> {
  if (mode === 'upload') {
    if (!file) throw new Error('Choose a document first.');
    return uploadKnowledge(file, onProgress);
  }
  const path = editing ? `/knowledge/${editing.id}` : '/knowledge';
  return api<Knowledge>(path, {method: editing ? 'PATCH' : 'POST', body: JSON.stringify(form)});
}

export function knowledgeForm(document: Knowledge | null): KnowledgeForm {
  if (!document) return {title: '', content: '', category: 'Other'};
  return {title: document.title, content: document.content, category: document.category};
}